/**
 * Descripción: Gestor del menú
 *
 * @displayName navbar
 */

export const namespaced = true;

export const state = {
  status: false,
  navbar: []
};

export const mutations = {
  SET_STATUS_DATA(state) {
    state.status = !state.status;
    localStorage.setItem('status', state.status);
  },
  UPDATE_STATUS_DATA(state, payload) {
    state.status = payload;
    localStorage.setItem('status', state.status);
  },
  PUSH(state, navbar) {
    state.navbar = [];
    state.navbar.push(...navbar);
  }
};

export const actions = {
  changeStatus({ commit }) {
    commit('SET_STATUS_DATA');
  },
  addNavbar({ commit }, navbar) {
    commit('PUSH', navbar);
  }
};
